import { Breakpoint, Card, Color } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  &:not(:last-of-type) {
    border-bottom: 1px solid ${Color.Gray300};
  }
`;

export const CardsGroupContainer = styled.div`
  padding: 40px 0;

  @media ${Breakpoint.SmallDesktop} {
    padding: 80px 0;
  }
`;

export const ContentTableWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 40px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 80px 0;
  }
`;

export const StyledCard = styled(Card)`
  max-width: 100%;
`;
